import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, TextField, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useHistory, useLocation } from 'react-router-dom';
import { getOptionsAsObject } from '../../utils/LocalStorage';
import './GlobalSearch.scss';

const GlobalSearch = () => {
  const [searchValue, setSearchValue] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [hotlinks, setHotlinks] = useState([]);
  const [videoLinks, setVideoLinks] = useState([]);
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState('');
  const [selectedVideoTitle, setSelectedVideoTitle] = useState('');
  const searchRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  

  // Get user profile and menus
  const { menus = [] , role = 1} = getOptionsAsObject('userProfile');

  // Define all valid navigatable links
  const staticHotlinks = [
    // Main Navigation
    // { title: 'Dashboard', url: '/dashboard', icon: '🏠', description: 'Overview of your learning progress and activities' },
    { title: 'My Courses', url: '/courses', icon: '📚', description: 'Browse and access all your enrolled courses' },
    // { title: 'Profile', url: '/profile', icon: '👤', description: 'Manage your personal information and settings' },

    // Classes & Learning
    // { title: 'Classes', url: '/classes', icon: '🎓', description: 'Join live classes and view recordings' },
    // { title: 'Setup Class', url: '/classes/setup-class', icon: '⚙️', description: 'Set up new live classes' },
    // { title: 'Join Class', url: '/classes/join-class', icon: '🚀', description: 'Join existing live classes' },
    // { title: 'Recordings', url: '/classes/recordings', icon: '📹', description: 'View recorded class sessions' },
    // { title: 'Recording View', url: '/classes/recording-view', icon: '👁️', description: 'Watch class recordings' },

    // Attendance Management
    // { title: 'Attendance', url: '/attendance', icon: '✅', description: 'Track and manage student attendance' },
    // { title: 'Students', url: '/attendance/students', icon: '👥', description: 'Manage student attendance records' },
    // { title: 'Teachers', url: '/attendance/teachers', icon: '👨‍🏫', description: 'View teacher attendance data' },
    // { title: 'Manage Attendance', url: '/attendance/manage-attendance', icon: '📊', description: 'Admin attendance management' },
    // { title: 'Take Attendance', url: '/attendance/take-attendance', icon: '✏️', description: 'Mark attendance for classes' },
    // { title: 'Student Reports', url: '/attendance/student-attendance-report', icon: '📈', description: 'Student attendance reports' },
    // { title: 'Teacher Reports', url: '/attendance/teacher-attendance-report', icon: '📊', description: 'Teacher attendance reports' },
    // { title: 'Class Reports', url: '/attendance/class-attendance-report', icon: '📋', description: 'Class-wise attendance reports' },
    // { title: 'View Attendance', url: '/attendance/viewattendance', icon: '👀', description: 'View attendance details' },
    // { title: 'Salary Reports', url: '/attendance/salary-attendance-report', icon: '💰', description: 'Salary-based attendance reports' },

    // Management
    { title: 'Assign Certificates', url: '/management/manage-users-by-teacher#certificate', icon: '🎓', description: 'Assign certificates to students' },
    { title: 'Assign Achievements', url: '/management/manage-users-by-teacher#achievement', icon: '🎓', description: 'Assign achievements to students' },
    { title: 'Assign Internship', url: '/management/manage-users-by-teacher#internship', icon: '🎓', description: 'Assign internship to students' },
    { title: 'Assign Projects', url: '/management/manage-users-by-teacher#project', icon: '🎓', description: 'Assign projects to students' },
    { title: 'Assign Courses', url: '/management/manage-users-by-teacher#course', icon: '🎓', description: 'Assign courses to students' },
    { title: 'Assign Skills Score', url: '/management/manage-users-by-teacher#skills', icon: '🎓', description: 'Assign skills score to students' },
    { title: 'Assign Badges', url: '/management/manage-users-by-teacher#badge', icon: '🎓', description: 'Assign badges to students' },
    { title: 'Users by Teacher', url: '/management/manage-users-by-teacher', icon: '👨‍🏫', description: 'Manage users assigned to teachers' },
    { title: 'Classes by Teacher', url: '/management/manage-classes-by-teacher', icon: '🎓', description: 'Manage classes assigned to teachers' },

    // Learning & Assessment
    // { title: 'Quizzes', url: '/quizzes', icon: '📝', description: 'Take quizzes and view your test results' },

    // System & Tools
    // { title: 'Servers', url: '/servers', icon: '🖥️', description: 'Access coding environments and servers' },

    // Logs & Monitoring
    // { title: 'Logs', url: '/logs', icon: '📊', description: 'View system logs and activity reports' },
    // { title: 'Programme Logs', url: '/logs/programme-log', icon: '📋', description: 'View programme activity logs' },
    // { title: 'Class Logs', url: '/logs/class-log', icon: '🏫', description: 'View class activity logs' },
    // { title: 'User Logs', url: '/logs/user-log', icon: '👤', description: 'View user activity logs' },
    // { title: 'Meeting Logs', url: '/logs/meeting-log', icon: '📞', description: 'View meeting activity logs' },
    // { title: 'Attendance Logs', url: '/logs/attendance-log', icon: '✅', description: 'View attendance activity logs' },
  ];

const TEACHER_VIDEOS_GUIDES = [
  {
    title: 'Getting Started For Schools and Teachers',
    url: 'https://youtu.be/O28MNMnX8Ag?si=Ahd2HqRRqOHcmOXO',
    icon: '🎬',
    description: 'Learn the basics of using the platform for Schools and Teachers',
  },
  {
    title: ' Direct access to all current courses and Classes managed by Teacher',
    url: 'https://confrecordings.ams3.cdn.digitaloceanspaces.com/GeneralTraining/module1/session1-ai_labs_walkthrough.mp4',
    icon: '📖',
    description: 'Direct access to all current courses and Classes managed by Teacher',
  },
  {
    title: 'Issue Certificates /Badges to Students',
    url: 'https://confrecordings.ams3.cdn.digitaloceanspaces.com/Demo%2FAssign_Certificates_and_PR.mp4',
    icon: '📤',
    description: 'Issue Certificates /Badges to Students',
  },
];

  const STUDENT_VIDEOS_GUIDES = [
    { title: 'Getting Started For Parents', url: 'https://youtu.be/qKHsvU54Aeo?si=ku49O5YiHBloRGO3', icon: '🎬', description: 'Learn the basics of using the platform for Parents' },
  ];

 

  const staticVideoLinks = role===4 ? TEACHER_VIDEOS_GUIDES : role==3 ? STUDENT_VIDEOS_GUIDES : [...TEACHER_VIDEOS_GUIDES, ...STUDENT_VIDEOS_GUIDES];

  // Build searchable items from menus and static links
  const buildSearchableItems = () => {
    const items = [];

    // Add static hotlinks
    staticHotlinks.forEach((link) => {
      items.push({
        title: link.title,
        url: link.url,
        type: 'page',
        icon: link.icon,
        category: 'Navigation',
      });
    });

    // Add static video links
    staticVideoLinks.forEach((link) => {
      items.push({
        title: link.title,
        url: link.url,
        type: 'video',
        icon: link.icon,
        category: 'Videos',
      });
    });

    // Add dynamic menu items
    menus.forEach((menu) => {
      items.push({
        title: menu.title,
        url: menu.url,
        type: 'page',
        icon: '📄',
        category: 'Menu',
      });

      // Add submenu items
      if (menu.subMenus) {
        menu.subMenus.forEach((subMenu) => {
          items.push({
            title: `${menu.title} - ${subMenu.title}`,
            url: subMenu.url,
            type: 'page',
            icon: '📄',
            category: 'Submenu',
          });
        });
      }
    });

    return items;
  };

  const searchableItems = buildSearchableItems();

  // Debounced search function
  const debouncedSearch = _.debounce((value) => {
    if (!value.trim()) {
      setSuggestions([]);
      return;
    }

    const filtered = searchableItems.filter((item) => item.title.toLowerCase().includes(value.toLowerCase()) || item.url.toLowerCase().includes(value.toLowerCase()));

    setSuggestions(filtered.slice(0, 8)); // Limit to 8 suggestions
  }, 300);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedSearch(value);
  };

  // Handle suggestion click
  const handleSuggestionClick = (url, type = 'page') => {
    setSearchValue('');
    setShowSuggestions(false);
    setSuggestions([]);
    
    // If it's a video, open dialog instead of navigating
    if (type === 'video') {
      setSelectedVideoUrl(url);
      // Find the video title from staticVideoLinks
      const video = staticVideoLinks.find(v => v.url === url);
      setSelectedVideoTitle(video?.title || 'Video');
      setVideoDialogOpen(true);
    } else {
      history.push(url);
    }
  };

  // Handle video link click
  const handleVideoClick = (video) => {
    setSelectedVideoUrl(video.url);
    setSelectedVideoTitle(video.title);
    setVideoDialogOpen(true);
    setSearchValue('');
    setShowSuggestions(false);
  };

  // Handle dialog close
  const handleVideoDialogClose = () => {
    setVideoDialogOpen(false);
    setSelectedVideoUrl('');
    setSelectedVideoTitle('');
  };

  // Handle input focus
  const handleFocus = () => {
    setShowSuggestions(true);
    if (!searchValue.trim()) {
      setHotlinks(staticHotlinks);
      setVideoLinks(staticVideoLinks);
    }
  };

  // Handle input blur
  const handleBlur = (e) => {
    // Delay hiding suggestions to allow clicks
    setTimeout(() => {
      setShowSuggestions(false);
    }, 200);
  };

  // Handle escape key
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setShowSuggestions(false);
      setSearchValue('');
    }
  };

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="global-search" ref={searchRef}>
      <TextField
        fullWidth
        placeholder="Search courses, classes, and more..."
        value={searchValue}
        onChange={handleSearchChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        variant="outlined"
        size="small"
        className="global-search-input"
        InputProps={{
          startAdornment: (
            <Box className="search-icon">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21.53,20.47l-4.694-4.695a8.264,8.264,0,1,0-1.061,1.061L20.47,21.53a.75.75,0,0,0,1.06-1.06ZM3.75,10.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,3.75,10.5Z"
                  fill="currentColor"
                />
              </svg>
            </Box>
          ),
        }}
      />

      {showSuggestions && (
        <Paper className="search-suggestions" elevation={3}>
          {searchValue.trim() ? (
            // Show search results
            <List className="suggestions-list">
              {suggestions.length > 0 ? (
                suggestions.map((item, index) => (
                  <ListItem key={index} button onClick={() => handleSuggestionClick(item.url, item.type)} className="suggestion-item">
                    <ListItemIcon className="suggestion-icon">{item.icon}</ListItemIcon>
                    <ListItemText primary={item.title} secondary={item.url} className="suggestion-text" />
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText primary="No results found" />
                </ListItem>
              )}
            </List>
          ) : (
            // Show hotlinks and video links when empty
            <Box className="empty-state-panel">
              <Box className="hotlinks-section">
                <Typography variant="h6" className="section-title">
                  Quick Links
                </Typography>
                <List className="hotlinks-list">
                  {staticHotlinks.map((link, index) => (
                    <ListItem key={index} button onClick={() => handleSuggestionClick(link.url)} className="hotlink-item">
                      <ListItemIcon className="hotlink-icon">{link.icon}</ListItemIcon>
                      <ListItemText primary={link.title} secondary={link.description} />
                    </ListItem>
                  ))}
                </List>
              </Box>

              <Divider orientation="vertical" flexItem className="divider" />

              <Box className="video-links-section">
                <Typography variant="h6" className="section-title">
                  Video Guides
                </Typography>
                <List className="video-links-list">
                  {staticVideoLinks.map((link, index) => (
                    <ListItem key={index} button onClick={() => handleVideoClick(link)} className="video-link-item">
                      <ListItemIcon className="video-link-icon">{link.icon}</ListItemIcon>
                      <ListItemText primary={link.title} secondary={link.description} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          )}
        </Paper>
      )}

      {/* Video Dialog */}
      <Dialog
        open={videoDialogOpen}
        onClose={handleVideoDialogClose}
        maxWidth="md"
        fullWidth
        aria-labelledby="video-dialog-title"
      >
        <DialogTitle id="video-dialog-title">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{selectedVideoTitle}</Typography>
            <IconButton aria-label="close" onClick={handleVideoDialogClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box style={{ position: 'relative', paddingTop: '56.25%' }}>
            <ReactPlayer
              url={selectedVideoUrl}
              width="100%"
              height="100%"
              style={{ position: 'absolute', top: 0, left: 0 }}
              controls={true}
              config={{
                youtube: {
                  playerVars: {
                    modestbranding: 1,
                    rel: 0,
                  },
                },
                file: {
                  attributes: {
                    controlsList: 'nodownload',
                  },
                },
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default GlobalSearch;
